import { useState } from "react";
import { alertService } from "../services/AlertService";
import { handleError } from "../model/handleError";
import EsamiService from "../services/EsamiService/EsamiService";

const useEsami = () => {
  const [loadingState, setLoadingState] = useState({
    getEsamiByIdCorso: false,
    isLoadingEsameCreating: false,
    isLoadingEsameDelete: false,
    isLoadingEsamiByClasseAndByToken: false,
    isLoadingEsameUpdate: false,
    getEsamiByIdClasse: false,
    getAllEsamiByIdClasse: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoEsame: false,
    showModalCreateEsame: false,
    showModalDeleteEsame: false,
    showModalUpdateEsame: false,
  });

  const getEsamiByIdCorso = async (courseId) => {
    setLoadingState({ ...loadingState, getEsamiByIdCorso: true });
    try {
      let response = await EsamiService.getEsamiByIdCorso(courseId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare gli esami",
        { autoClose: true }
      );
    } finally {
      setLoadingState({ ...loadingState, getEsamiByIdCorso: false });
    }
  };

  const getEsamiByIdClasse = async (classId) => {
    setLoadingState({ ...loadingState, getEsamiByIdClasse: true });
    try {
      let response = await EsamiService.getEsamiByIdClasse(classId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare gli esami",
        { autoClose: true }
      );
    } finally {
      setLoadingState({ ...loadingState, getEsamiByIdClasse: false });
    }
  };

  const getAllEsamiByIdClasse = async (classId) => {
/*     setLoadingState({ ...loadingState, getAllEsamiByIdClasse: true }); */
    try {
      let response = await EsamiService.getAllEsamiByIdClasse(classId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare gli esami",
        { autoClose: true }
      );
    } finally {
  /*     setLoadingState({ ...loadingState, getAllEsamiByIdClasse: false }); */
    }
  };

  const getEsamiByClasseAndByToken = async (classId) => {
    setLoadingState({ ...loadingState, isLoadingEsamiByClasseAndByToken: true });
    try {
      let response = await EsamiService.getEsamiByClasseAndByToken(classId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare gli esami",
        { autoClose: true }
      );
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsamiByClasseAndByToken: false });
    }
  };

  const createEsame = async (data) => {
    setLoadingState({ ...loadingState, isLoadingEsameCreating: true });
    try {
      let response = await EsamiService.createEsame(data);
      if(response !== -1){
        alertService.success("Esame creato con successo", { autoClose: true });
        setModalState({ ...modalState, showModalCreateEsame: false });
      }
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameCreating: false });
    }
  };

  const deleteEsame = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingEsameDelete: true });
      await EsamiService.deleteEsame(id);
      alertService.success("Esame eliminato con successo", {
        autoClose: true,
      });
      setModalState({ ...modalState, showModalDeleteEsame: false });
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameDelete: false });
    }
  };

  const updateEsame = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingEsameUpdate: true });
      let response = await EsamiService.updateEsame(data);
      if(response !== -1){
        alertService.success("Esame aggiornato con successo", {
          autoClose: true,
        });
        setModalState({ ...modalState, showModalUpdateEsame: false });
      }
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameUpdate: false });
    }
  };

  return {
    getEsamiByIdCorso,
    getEsamiByIdClasse,
    getAllEsamiByIdClasse,
    createEsame,
    deleteEsame,
    updateEsame,
    getEsamiByClasseAndByToken,
    loadingStateEsami: loadingState,
    modalStateEsami: modalState,
  };
};

export default useEsami;

